import { render, staticRenderFns } from "./CmgMemberRewardItem.vue?vue&type=template&id=41878171&scoped=true&lang=pug"
import script from "./cmg-member-reward-item.ts?vue&type=script&lang=ts&external"
export * from "./cmg-member-reward-item.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMemberRewardItem.vue?vue&type=style&index=0&id=41878171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41878171",
  null
  
)

export default component.exports